// Centralized WhatsApp configuration.
// Update the phone number here and every CTA across the site will follow.

export const WHATSAPP_NUMBER = '34689621262'

/**
 * Per-origin messages so the business knows exactly where the lead came from.
 * Add new keys here if you add new CTA locations.
 */
const DEFAULT_MESSAGE = 'Hola, quiero más información sobre las experiencias'
const DEFAULT_MESSAGE_EN =
  'Hi, I would like more information about the experiences.'

export const WHATSAPP_MESSAGES = {
  hero: DEFAULT_MESSAGE,
  navbar: DEFAULT_MESSAGE,
  middle: DEFAULT_MESSAGE,
  finalCta: DEFAULT_MESSAGE,
  about: DEFAULT_MESSAGE,
  floating: DEFAULT_MESSAGE,
  contact: DEFAULT_MESSAGE,
  general: DEFAULT_MESSAGE,
  brunch: DEFAULT_MESSAGE,
  sunset: DEFAULT_MESSAGE,
  love: DEFAULT_MESSAGE,
} as const

export type WhatsAppOrigin = keyof typeof WHATSAPP_MESSAGES

/**
 * Build the wa.me URL with an encoded message.
 * Pass either a known origin key or a free-form custom message.
 */
export function whatsappLink(
  originOrMessage: WhatsAppOrigin | string,
  lang: 'es' | 'en' = 'es',
): string {
  let message = originOrMessage
  if (originOrMessage in WHATSAPP_MESSAGES) {
    message =
      lang === 'en'
        ? DEFAULT_MESSAGE_EN
        : WHATSAPP_MESSAGES[originOrMessage as WhatsAppOrigin]
  }
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`
}
